import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsSelectTableDecoratorsComponent } from './decorators.component';
import { RdsGetRecordValuePipe } from './get-record-value.pipe';
import { RdsIsRecordValueNumberPipe } from './is-number.pipe';
import { RdsSelectTableComponent } from './select-table.component';

const COMPONENTS = [RdsSelectTableComponent, RdsSelectTableDecoratorsComponent];
const PIPES = [RdsGetRecordValuePipe, RdsIsRecordValueNumberPipe];

@NgModule({
  imports: [CommonModule, DragDropModule, MatCheckboxModule, MatTableModule, MatRippleModule, MatTooltipModule],
  declarations: [COMPONENTS, PIPES],
  exports: [COMPONENTS, PIPES]
})
export class RdsSelectTableModule {}

export * from './decorators.component';
export * from './get-record-value.pipe';
export * from './is-number.pipe';
export * from './select-table.component';
